import React from 'react';

import './settingsFont.scss';

import { FontArray } from '../../FontArray';
import { useFonts } from '../../../LeftWorkArea/LeftWorkFonts/useFonts';

export const SettingsFont = () => {
  const { handleFont } = useFonts();

  return <FontArray onFontChanged={handleFont} />
}